import React from 'react';
import PropTypes from 'prop-types';
import { HeadingStyledTag } from './styles';

const Heading = ({
  tag,
  type,
  style,
  children,
  iconRight,
  withCursor,
  onClick,
  testid,
  dangerouslySetInnerHTML,
  ...rest
}) => {
  if (dangerouslySetInnerHTML)
    return (
      <HeadingStyledTag
        as={tag ?? `h${type}`}
        data-testid={testid}
        type={type}
        withCursor={!!withCursor || !!onClick}
        style={style}
        onClick={onClick}
        dangerouslySetInnerHTML={dangerouslySetInnerHTML}
        {...rest}
      />
    );

  return (
    <HeadingStyledTag
      as={tag ?? `h${type}`}
      data-testid={testid}
      type={type}
      withCursor={!!withCursor || !!onClick}
      style={style}
      onClick={onClick}
      {...rest}
    >
      {children}
      {iconRight}
    </HeadingStyledTag>
  );
};

Heading.propTypes = {
  tag: PropTypes.elementType,
  type: PropTypes.number,
  style: PropTypes.object,
  children: PropTypes.node,
  withCursor: PropTypes.bool,
  onClick: PropTypes.func,
  iconRight: PropTypes.element,
  testid: PropTypes.string,
  dangerouslySetInnerHTML: PropTypes.object,
};

Heading.defaultProps = {
  type: 1,
};

export default React.memo(Heading);
